<template>
    <div class="overlay">
        <div class="__modal">
            <div class="modal__title">
                <span>Session Expired</span>
            </div>
            <div class="p-3"> 
    		    <p>You have left this browser idle for 10 minutes.</p>
    		    <p>{{ time }} second left</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
		return {
			time: 10000
		}
    },
    created() {
        let timerId = setInterval(() => {
            this.time -= 1000;

            if (!this.$store.state.idleVue.isIdle) clearInterval(timerId);
            if (this.time < 1) {
                clearInterval(timerId);
                this.logout();
            }
        }, 1000);
    },
    methods: {
        logout() {
            try {
                localStorage.removeItem('user')
                localStorage.removeItem('jwt')
                this.$router.push('/login')
            } catch(err) {
                console.log(err)
            }
        }
    }
}
</script>
<style lang="postcss" scoped>
    .overlay {
        position: fixed !important;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.3);
        z-index: 200 !important;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .__modal {
        width: 500px !important;
        box-shadow: 1px 2px 4px rgba(153, 155, 168, 0.12) !important;
        border-radius: 4px;
        background-color: #fff !important;
        padding: 20px !important;
    }

    .modal__title {
        color: #38404f;
        font-weight: bold;
    }
</style>